'use client'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../_components/ui/accordion'

interface FaqItemProps {
  question: string
  answer: string
}

export const FaqItem = ({ question, answer }: FaqItemProps) => {
  return (
    <Accordion
      className="min-h-[68px] rounded-xl bg-brand-grayscale-2 p-6"
      type="single"
      collapsible
    >
      <AccordionItem value="item-1" className="flex flex-col gap-3 border-b-0">
        <AccordionTrigger className="p-0 text-left font-medium sm:font-semibold">
          {question}
        </AccordionTrigger>
        <AccordionContent className="hyphens-auto text-base text-brand-grayscale-8">
          {answer}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
